import { getApiInstance } from '../helpers';
import { AssigneesResI } from '../models/Assignees';
const loadAssignees = () => {
  return getApiInstance()
    .get('/user/list')
    .then((res) => {
      console.info('/user/list', res);
      return res.data as AssigneesResI;
    });
};

export const assigneesServices = {
  loadAssignees,
};
